import { render } from "./IncidentsTable.vue?vue&type=template&id=5af93e06&scoped=true&ts=true"
import script from "./IncidentsTable.vue?vue&type=script&lang=ts"
export * from "./IncidentsTable.vue?vue&type=script&lang=ts"

import "./IncidentsTable.vue?vue&type=style&index=0&id=5af93e06&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Pablo\\Documents\\Programacion\\Playas\\beachguard_v3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5af93e06"]])

export default __exports__